<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange"
               @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permissionList.delBtn"
                   @click="handleDelete">删 除
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">

        <el-button type="text"
                   size="small"
                   icon="el-icon-view"
                   v-if="permissionList.logBtn"
                   @click="handleViewLog(scope.row)">日志
        </el-button>

        <el-button type="text"
                   size="small"
                   v-if="(scope.row.status == 0 || scope.row.status == 4) && permissionList.toExamineBtn"
                   @click="handleToExamine(scope.row,1)">审核提交
        </el-button>
        <el-button type="text"
                   size="small"
                   v-if="scope.row.status == 1 && permissionList.toExamineBtn"
                   @click="handleToExamine(scope.row,2)">审核通过
        </el-button>
        <el-button type="text"
                   size="small"
                   v-if="scope.row.status == 1 && permissionList.toExamineBtn"
                   @click="handleToExamine(scope.row,3)">审核拒绝
        </el-button>

        <el-button type="text"
                   size="small"
                   v-if=" scope.row.status != 0 && scope.row.status != 2 && scope.row.status != 4 && permissionList.toExamineBtn"
                   @click="handleToExamine(scope.row,4)">
                   审核撤销
        </el-button>
      </template>
    </avue-crud>
    <!-- 日志弹窗 -->
    <el-dialog
      title="操作日志"
      :visible.sync="logDialogVisible"
      width="70%"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @closed="handleLogDialogClosed" append-to-body>
      <avue-crud :option="logOption"
               :table-loading="loading"
               ref="LogCrud"
               :data="Logdata"
               :page="logPage">
      </avue-crud>
    </el-dialog>
  </basic-container>
</template>

<script>
  import {getList, getDetail, add, update, remove,toExamine} from "@/api/desk/videodecodesupportrecord";
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        logPage: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
         
          // height:'500px', // 不设置高度，让表格自己撑开
          calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 4,
          border: true,
          index: true,
          viewBtn: true,
          selection: true,
          dialogClickModal: false,
          labelWidth: 120,    // 标签宽度
          labelPosition: 'right', // 标签位置
          span: 8,
          column: [
            {
              label: "厂商",
              prop: "manufacturer",
              span: 6,
              editDisabled: true,
              search: true,
              searchLabelWidth: 1,
              searchSpan: 4,
            },
            {
              label: "机型",
              prop: "model",
              span: 6,
              editDisabled: true,
              search: true,
              searchLabelWidth: 1,
              searchSpan: 4,
            },
            {
              label: "芯片",
              prop: "chip",
              span: 6,
              searchLabelWidth: 1,
              editDisabled: true,
              formatter: (row, value) => {
                return value;
              },
              cellStyle: {
                'white-space': 'nowrap',
                'text-overflow': 'ellipsis',
                'overflow': 'hidden',
                'max-width': '150px'
              },
              overHidden: true,
              tip: true
            },
            {
              label: "系统版本",
              prop: "osVersion",
              span: 6,
              editDisabled: true,
              search: true,
              searchLabelWidth: 1,
              searchSpan: 4,
            },
            {
              label: "低延时解码",
              searchLabelWidth: 1,
              search: true,
              searchSpan: 4,
              prop: "supportLowLatency",
              span: 8,
              type: "select",
              dicData: [
                {
                  label: "支持",
                  value: 1
                },
                {
                  label: "不支持",
                  value: 0
                },
                {
                  label: "未知",
                  value: -1
                }
              ],
              rules: [{
                required: true,
                message: "请输入低延时支持：1支持 0不支持 -1未知",
                trigger: "blur"
              }]
            },
            {
              label: "低延时标记",
              search: true,
              searchLabelWidth: 1,
              searchSpan: 4,
              span: 8,
              prop: "lowLatencyMarked",
              type: "select",
              dicData: [
                {
                  label: "人工标记",
                  value: 1
                },
                {
                  label: "系统标记",
                  value: 0
                },
                {
                  label: "-",
                  value: -1
                }
              ],
              rules: [{
                required: true,
                message: "请输入低延时标记",
                trigger: "blur"
              }]
            },
            {
              label: "说明",
              span: 8,
              renderHeader: (h) => {
                return h('el-tooltip', {
                  props: {
                    content: "低延时标记说明",
                    placement: "top"
                  }
                }, [
                  h('span', {}, "说明")
                ]);
              },
              prop: "lowLatencyMarkedReason",
              overHidden: true,
              tip: true,
              cellStyle: {
                'white-space': 'nowrap',
                'text-overflow': 'ellipsis',
                'overflow': 'hidden',
                'max-width': '150px'
              },
              rules: [{
                required: true,
                message: "请输入低延时标记说明",
                trigger: "blur"
              }]
            },
            {
              label: "4K解码",
              searchLabelWidth: 1,
              searchSpan: 4,
              span: 8,
              search: true,
              prop: "supportF4k",
              type: "select",
              dicData: [
                {
                  label: "支持",
                  value: 1
                },
                {
                  label: "不支持",
                  value: 0
                },
                {
                  label: "未知",
                  value: -1
                }
              ],
              rules: [{
                required: true,
                message: "请输入4K解码能力:1支持 0不支持 -1未知",
                trigger: "blur"
              }]
            },
            {
              label: "4K解码标记",
              searchLabelWidth: 1,
              searchSpan: 4,
              span: 8,
              search: true,
              prop: "f4kMarked",
              type: "select",
              dicData: [
                {
                  label: "人工标记",
                  value: 1
                },
                {
                  label: "系统标记",
                  value: 0
                },
                {
                  label: "-",
                  value: -1
                }
              ],
              rules: [{
                required: true,
                message: "请输入4K解码标记",
                trigger: "blur"
              }]
            },
            {
              label: "说明",
              searchLabelWidth: 1,
              span: 8,
              labelTip: true,
              renderHeader: (h) => {
                return h('el-tooltip', {
                  props: {
                    content: "4K解码标记说明",
                    placement: "top"
                  }
                }, [
                  h('span', {}, "说明")
                ]);
              },
              prop: "f4kMarkedReason",
              overHidden: true,
              tip: true,
              cellStyle: {
                'white-space': 'nowrap',
                'text-overflow': 'ellipsis',
                'overflow': 'hidden',
                'max-width': '150px'
              },
              rules: [{
                required: true,
                message: "请输入4K解码标记说明",
                trigger: "blur"
              }]
            },
            {
              label: "H265解码",
              searchLabelWidth: 1,
              searchSpan: 4,
              span: 8,
              search: true,
              prop: "supportH265",
              type: "select",
              dicData: [
                {
                  label: "支持",
                  value: 1
                },
                {
                  label: "不支持",
                  value: 0
                },
                {
                  label: "未知",
                  value: -1
                }
              ],
              rules: [{
                required: true,
                message: "请输入H265支持:1支持 0不支持 -1未知",
                trigger: "blur"
              }]
            },
            {
              label: "H265解码标记",
              searchLabelWidth: 1,
              searchSpan: 4,
              span: 8,
              search: true,
              prop: "h265Marked",
              type: "select",
              dicData: [
                {
                  label: "人工标记",
                  value: 1
                },
                {
                  label: "系统标记",
                  value: 0
                },
                {
                  label: "-",
                  value: -1
                }
              ],
              rules: [{
                required: true,
                message: "请输入H265解码状态是否人工标记",
                trigger: "blur"
              }]
            },
            {
              label: "说明",
              span: 8,
              renderHeader: (h) => {
                return h('el-tooltip', {
                  props: {
                    content: "H265解码标记说明",
                    placement: "top"
                  }
                }, [
                  h('span', {}, "说明")
                ]);
              },
              prop: "h265MarkedReason",
              overHidden: true,
              tip: true,
              cellStyle: {
                'white-space': 'nowrap',
                'text-overflow': 'ellipsis',
                'overflow': 'hidden',
                'max-width': '150px'
              },
              rules: [{
                required: true,
                message: "请输入H265解码标记说明",
                trigger: "blur"
              }]
            },
            {
              label: "最大帧率",
              searchLabelWidth: 1,
              searchSpan: 4,
              prop: "maxFps",
              span: 8,
              search: true,
              rules: [{
                required: true,
                message: "请输入最大帧率",
                trigger: "blur"
              }]
            },
            {
              label: "最大帧率标记",
              searchLabelWidth: 1,
              prop: "maxFpsMarked",
              span: 8,
              search: true,
              type: "select",
              searchSpan: 4,
              dicData: [
                {
                  label: "人工标记",
                  value: 1
                },
                {
                  label: "系统标记",
                  value: 0
                },
                {
                  label: "-",
                  value: -1
                }
              ],
              rules: [{
                required: true,
                message: "请输入最大帧率标记",
                trigger: "blur"
              }]
            },
            {
              label: "说明",
              span: 8,
              renderHeader: (h) => {
                return h('el-tooltip', {
                  props: {
                    content: "最大帧率标记说明",
                    placement: "top"
                  }
                }, [
                  h('span', {}, "说明")
                ]);
              },
              prop: "maxFpsMarkedReason",
              overHidden: true,
              tip: true,
              cellStyle: {
                'white-space': 'nowrap',
                'text-overflow': 'ellipsis',
                'overflow': 'hidden',
                'max-width': '150px'
              },
              rules: [{
                required: true,
                message: "请输入最大帧率标记说明",
                trigger: "blur"
              }]
            },
            {
              label: "数据来源",
              searchLabelWidth: 1,
              searchSpan: 4,
              prop: "dataSource",
              search: true,
              type: "select",
              dicData: [
                {
                  label: "SDK",
                  value: 1
                },
                {
                  label: "大数据",
                  value: 2
                },
                {
                  label: "历史数据",
                  value: 3
                },
                {
                  label: "其他",
                  value: 4
                }
              ],
              rules: [{
                required: true,
                message: "请输入数据来源 1-SDK 2-大数据 3-历史数据,4-其他",
                trigger: "blur"
              }]
            },
            {
              label: "审核状态",
              searchLabelWidth: 1,
              searchSpan: 4,
              prop: "status",
              search: true,
              type: "select",
              addDisplay: false,
              editDisplay: false,
              dicData: [
                {
                  label: "待审核",
                  value: 0
                },
                {
                  label: "提交审核",
                  value: 1
                },
                {
                  label: "审核通过",
                  value: 2
                },
                {
                  label: "审核拒绝",
                  value: 3
                },
                {
                  label: "撤销审核",
                  value: 4
                }
              ]
            },
            {
              label: "创建时间",
              prop: "createdtime",
              addDisplay: false,  // 在新增表单中隐藏
              editDisplay: false, // 在编辑表单中隐藏
            },
            {
              label: "修改时间",
              prop: "updatedtime",
              addDisplay: false,  // 在新增表单中隐藏
              editDisplay: false, // 在编辑表单中隐藏
            },
          ]
        },
        logOption:{
          calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          addBtn: false,  // 禁用新增按钮
          columnBtn: false, // 禁用显示/隐藏列按钮
          refreshBtn: true, // 保留刷新按钮
          border: true,
          index: true,
          viewBtn: true,
          selection: true,
          dialogClickModal: false,
          labelWidth: 120,    // 标签宽度
          labelPosition: 'right', // 标签位置
          span: 8,
          column: [
          ]
        },
        data: [],
        logDialogVisible: false
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.videodecodesupportrecord_add, false),
          viewBtn: this.vaildData(this.permission.videodecodesupportrecord_view, false),
          delBtn: this.vaildData(this.permission.videodecodesupportrecord_delete, false),
          logBtn: this.vaildData(this.permission.videodecodesupportrecord_log, false),
          editBtn: this.vaildData(this.permission.videodecodesupportrecord_edit, false),
          toExamineBtn: this.vaildData(this.permission.videodecodesupportrecord_toexamine, false)

        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    methods: {
      rowSave(row, loading, done) {
        add(row).then(() => {
          loading();
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        }, error => {
          done();
          console.log(error);
        });
      },
      rowUpdate(row, index, loading, done) {
        update(row).then(() => {
          loading();
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        }, error => {
          done();
          console.log(error);
        });
      },
      rowDel(row) {
        console.log(row);
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove(row.id);
          })
          .then(() => {
            this.onLoad(this.page);
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove(this.ids);
          })
          .then(() => {
            this.onLoad(this.page);
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail(this.form.id).then(res => {
            this.form = res.data.data;
          });
        }
        done();
      },
      searchReset() {
        this.query = {};
        this.onLoad(this.page);
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad(this.page, params);
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage){
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize){
        this.page.pageSize = pageSize;
      },
      refreshChange() {
        this.onLoad(this.page, this.query);
      },
      onLoad(page, params = {}) {
        this.loading = true;
        getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(res => {
          const data = res.data.data;
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      },
      // 查看日志方法
      handleViewLog(row) {
        //this.logDialogVisible = true
        // 这里实现查看日志的逻辑
        this.$message.info(`查看ID为 ${row.id} 的记录日志,开发中...`);
        // 示例：跳转到日志页面
        // this.$router.push({
        //   path: '/log/detail',
        //   query: {
        //     id: row.id,
        //     type: 'videodecodesupportrecord'
        //   }
        // });
      },
      handleToExamine(row, newStatus) {
        // 根据不同状态显示不同的确认信息
        let actionText = '';
        switch(newStatus) {
          case 1:
            actionText = '提交审核';
            break;
          case 2:
            actionText = '审核通过';
            break;
          case 3:
            actionText = '审核拒绝';
            break;
          case 4:
            actionText = '撤销审核';
            break;
          default:
            actionText = '更改状态';
        }
        // 显示确认对话框
        this.$confirm(`确定要${actionText}该记录吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 用户点击确定，执行操作
          toExamine({id: row.id, status: newStatus}).then(res => {
            this.$message.success(`${actionText}成功: ${res.data.message}`);
            this.onLoad(this.page);
          }).catch(err => {
            this.$message.error(`${actionText}失败: ${err.data ? err.data.message : err.message}`);
            console.log(err);
          });
        }).catch(() => {
          // 用户点击取消，不执行任何操作
          this.$message.info('已取消操作');
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
/* 设置操作栏宽度 */
.avue-crud__menu {
  min-width: 350px !important;
  width: 350px !important;
}

/* 确保操作按钮在一行显示 */
.avue-crud__menu .el-button {
  margin-right: 8px;
}

/* 如果按钮太多，可以设置为多行显示 */
.avue-crud__menu .cell {
  white-space: normal;
}
/* 表格单元格文本溢出处理 */
.el-table .cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* 确保tooltip正常显示 */
.el-tooltip__popper {
  max-width: 300px;
  word-break: break-all;
  line-height: 1.5;
}

/* 自定义单元格样式 */
.truncate-cell {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.avue-crud {
  /deep/ .avue-form__group {
    .el-form-item__label {
      display: none !important;
    }

  }
}
</style>
